import React from 'react';

const InIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="32"
    height="31"
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.79134 25.833C1.79134 27.9731 3.52618 29.708 5.66634 29.708L26.333 29.708C28.4731 29.708 30.208 27.9731 30.208 25.833L30.208 12.9163C30.208 10.7762 28.4731 9.04134 26.333 9.04134L25.0413 9.04134C24.328 9.04134 23.7497 9.61962 23.7497 10.333C23.7497 11.0464 24.328 11.6247 25.0413 11.6247L26.333 11.6247C27.0464 11.6247 27.6247 12.203 27.6247 12.9163L27.6247 20.6663L4.37467 20.6663L4.37467 12.9163C4.37467 12.203 4.95295 11.6247 5.66634 11.6247L6.958 11.6247C7.67139 11.6247 8.24967 11.0464 8.24967 10.333C8.24967 9.61962 7.67139 9.04134 6.958 9.04134L5.66634 9.04134C3.52617 9.04134 1.79134 10.7762 1.79134 12.9163L1.79134 25.833ZM4.37467 23.2497L4.37467 25.833C4.37467 26.5464 4.95295 27.1247 5.66634 27.1247L26.333 27.1247C27.0464 27.1247 27.6247 26.5464 27.6247 25.833L27.6247 23.2497L4.37467 23.2497Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.79134 25.833C1.79134 27.9731 3.52618 29.708 5.66634 29.708L26.333 29.708C28.4731 29.708 30.208 27.9731 30.208 25.833L30.208 12.9163C30.208 10.7762 28.4731 9.04134 26.333 9.04134L25.0413 9.04134C24.328 9.04134 23.7497 9.61962 23.7497 10.333C23.7497 11.0464 24.328 11.6247 25.0413 11.6247L26.333 11.6247C27.0464 11.6247 27.6247 12.203 27.6247 12.9163L27.6247 20.6663L4.37467 20.6663L4.37467 12.9163C4.37467 12.203 4.95295 11.6247 5.66634 11.6247L6.958 11.6247C7.67139 11.6247 8.24967 11.0464 8.24967 10.333C8.24967 9.61962 7.67139 9.04134 6.958 9.04134L5.66634 9.04134C3.52617 9.04134 1.79134 10.7762 1.79134 12.9163L1.79134 25.833ZM4.37467 23.2497L4.37467 25.833C4.37467 26.5464 4.95295 27.1247 5.66634 27.1247L26.333 27.1247C27.0464 27.1247 27.6247 26.5464 27.6247 25.833L27.6247 23.2497L4.37467 23.2497Z"
      fill="white"
    />
    <path
      d="M14.7087 2.58315C14.7087 1.86977 15.287 1.29149 16.0003 1.29149C16.7137 1.29149 17.292 1.86977 17.292 2.58315L17.292 9.80757L18.962 8.13784C19.4664 7.63318 20.2842 7.63318 20.7887 8.13784C21.2931 8.64197 21.2931 9.45999 20.7887 9.96425L16.9143 13.8306C16.4098 14.3342 15.5927 14.3337 15.0886 13.8297L11.2147 9.95573C10.7102 9.4512 10.7102 8.63345 11.2147 8.12893C11.7191 7.62466 12.537 7.62466 13.0414 8.12893L14.7087 9.79621L14.7087 2.58315Z"
      fill="white"
    />
  </svg>
);

export default InIcon;
